import PageHero from "./PageHero";

const ContactHero = () => {
  return (
    <PageHero
      title={<>Get in <span className="text-gradient-brand">Touch</span></>}
      description="Let's discuss how AI can transform your business."
      blobPosition="right"
    />
  );
};

export default ContactHero;
